import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankCheckIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 11.2125L11 5.87915L19 11.2125",
			stroke: "#000000",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 21.8792H19",
			stroke: "#000000",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.66699 19.2125V13.8792",
			stroke: "#000000",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.22266 19.2125V13.8792",
			stroke: "#000000",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7773 19.2125V13.8792",
			stroke: "#000000",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.333 19.2125V13.8792",
			stroke: "#000000",
			strokeWidth: 1.33333,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 2.87915L18.875 6.87915L17 4.87915",
			stroke: "#000000",
			strokeWidth: 1.3,
			strokeLinecap: "square"
		})
	]
});
export default SvgBankCheckIcon;
